<template>
  <div class="wrp">
    <div class="top clear">
      <div class="back">
        <span @click="$router.go(-1)"><i class="el-icon-back"></i>Back</span>
      </div>
      <div class="search">
        <input type="text" @input="watchkey" v-model="key" />
      </div>
    </div>
    <p>Please select the Peiso venue you want to connect to</p>
    <div class="table-wrp account" style="min-width:890px">
      <el-table
          :data="tableData2"
          style="width: 100%">
        <el-table-column
          label="Venue"
          prop="venueName">
        </el-table-column>
        <el-table-column
          label="Username"
          prop="userName">
        </el-table-column>
        <el-table-column
          label="Contact Number"
          prop="venueMobile">
        </el-table-column>
        <el-table-column
          label="Venue Owner"
          prop="venueOwner">
        </el-table-column>
        <el-table-column
          label="Venue Address"
          prop="venueAddress">
        </el-table-column>
        <el-table-column
          label="Operation"
          width="120">
          <template slot-scope="scope">
            <div class="btns clear">
              <button class="dark" @click="connect(scope.row.id)">Connect</button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
        </template>
      </el-table>
      <div class="ros_footerPage">
        <el-pagination
            v-if="!loading"
            class="my_pageSel"
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :current-page.sync="page"
            :total="totalRecord">
        </el-pagination>
    </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/doshii'
import http from '../../api/account'

export default {
  data () {
    return {
      tableData2: [],
      loading: true, // 是否正在加载
      totalRecord: 0,
      page: 1,
      pagesize: 10,
      timeout: null,
      key: ''
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      const data = {
        pageNum: this.page,
        pageSize: this.pagesize
      }
      if (this.key.replace(/\s+/g,'') !== '')
        data.keyword = this.key
      http.getLst({
        params: data, 
        callback: this.lstCallback
      })
    },
    connect (id) {
      var that = this
      that.$box.loadings()
      api.connectVenue({
        params: {
          id: that.$route.params.id,
          venueId: id
        },
        callback: (res) => {
          that.$box.loadings(2)
          if(res.data.code == 0){
            Utils.alert('', 'Connection Succeeded', 'success')
          } else{
            Utils.alert('', res.data.message, 'error')
          }
        }
      })
    },
    pageChange (page) {
      this.page = page
      this.tableData2 = []
      this.loading = true
      // 加载表格
      this.getList()
    },
    lstCallback (res) {
      var that = this
      if(res.data.code == 0){
        that.loading = false
        res.data.data.list.forEach(item => {
          item.createTime = that.$box.timestampToTime(item.createTime)
          item.venueMobile = that.$box.formatNumber(item.venueMobile)
          item.monthlyFee = Utils.formatSplit(item.monthlyFee)
        })
        this.tableData2 = res.data.data.list
        this.totalRecord = res.data.data.total
      } else{
        that.loading = false
        Utils.alert('', res.data.message, 'error')
      }
    },
    // 搜索关键词，
    keySearch () {
      this.page = 1
      this.getList()
    },
    watchkey() {
      var that = this
      if (that.timeout) {
          clearTimeout(that.timeout)
      }
      that.timeout = setTimeout(() => {
          that.keySearch.call(that, that.key)
      }, 2000) 
    }
  },
}
</script>

<style lang="scss" scoped>
.ros_footerPage{
    display: flex;
    justify-content: center;
}
.wrp{
  color: #fff;
  padding-bottom: 50px;
  .top{
    width: 100%;
    margin-bottom: 39px;
    .back{
        font-size: 14px;
        line-height: 16px;
        color: #fff;
        margin-bottom: 56px;
        font-family: 'SFProText-Semibold';
        background: #212429;
        z-index: 5;
        height: 20px;
        float: left;
        span{
            display: inline-block;
            width: 100px;
            cursor: pointer;
            i{
            margin-right: 10px;
            }
        }
    }
    .search{
      float: right;
      width: 300px;
      border-bottom: 1px solid #fff;
      background-size: 24px 22px;
      background-position: left center;
      background-repeat: no-repeat;
      background-image: url('../../assets/s.png');
      margin-top: -3px;
      input{
        outline: none;
        border: none;
        line-height: 30px;
        font-size: 16px;
        font-family:'PingFangSC-Regular,PingFang SC';
        width: 100%;
        background-color: transparent;
        color: #fff;
        box-sizing: border-box;
        padding-left: 30px;
      }
    }
  }
  p{
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 33px;
    margin-bottom: 30px;
  }
  .table-wrp{
    .btns{
      margin-bottom: 0;
    }
    .dark{
      width: 100px;
      height: 40px;
      background: #151C27;
      border: 1px solid #FFFFFF;
      outline: none;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/doshii/connect.vue